export class Error {
    code: string;
    message: string;
}


// WEBPACK FOOTER //
// ./src/app/models/error.ts